import React from "react";

import { Button } from "@replohq/lattice/components/button/Button";
import { useSidebar } from "@replohq/lattice/components/sidebar/Sidebar";
import { Tooltip } from "@replohq/lattice/components/tooltip/Tooltip";
import { useChatSidebar } from "@v2/features/chat/hooks/useChatSidebar";
import { DebugMenu } from "@v2/features/debug/DebugMenu";
import { useIsDebugMode } from "@v2/hooks/useIsDebugMode";
import { Menu, MessagesSquare } from "lucide-react";

export default function MobileChatHeader() {
  const { toggleSidebar } = useSidebar();
  const { toggle } = useChatSidebar();
  const isDebugMode = useIsDebugMode();

  return (
    <div className="md:hidden fixed top-0 left-0 right-0 z-40 bg-white w-full flex items-center justify-between h-14 px-3 border-b-0.5 border-border">
      <Tooltip content="Menu" triggerAsChild>
        <Button
          icon
          variant="tertiary"
          size="lg"
          onClick={toggleSidebar}
          aria-label="Open menu"
        >
          <Menu />
        </Button>
      </Tooltip>
      {isDebugMode && <DebugMenu />}
      <Tooltip content="Chats" triggerAsChild>
        <Button
          icon
          variant="tertiary"
          size="lg"
          onClick={toggle}
          aria-label="Open chats"
        >
          <MessagesSquare />
        </Button>
      </Tooltip>
    </div>
  );
}
